/* global Office console */

export async function insertFormValues({ values, t }) {
  // Write text to the cursor point in the compose surface.

  const formattedValues = `
  <p><b>${t("Email_#Task Details")}:</b></p>
  <ul>
    <li><b>${t("Email_#Description")}:</b> ${values.task_description}</li>
    <li><b>${t("Email_#Type")}:</b> ${values.task_type}</li>
    <li><b>${t("Email_#Deadline")}:</b> ${values.task_deadline}</li>
    <li><b>${t("Email_#Urgency")}:</b> ${values.task_urgency}</li>
  </ul>
`;

  try {
    Office.context.mailbox.item?.body.setSelectedDataAsync(
      formattedValues,
      { coercionType: Office.CoercionType.Html },
      (asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
          throw asyncResult.error.message;
        }
      }
    );
  } catch (error) {
    console.log("Error: " + error);
  }
}
